import React from "react";
import TypographyInput from "./TypographyInput";

const TypographyInputs = ({ label, inputs, setInputs }) => {
  return (
    <div className="typography-inputs-container">
      <div className="typography-inputs-label">{label}</div>
      <div className="typography-inputs">
        <TypographyInput
          label="Base Font Size"
          inputs={inputs}
          setInputs={setInputs}
          inputValue={inputs["Base Font Size"]}
        />
        <TypographyInput
          label="XS-M Line Height"
          inputs={inputs}
          setInputs={setInputs}
          inputValue={inputs["XS-M Line Height"]}
        />
        <TypographyInput
          label="Modular Scale"
          inputs={inputs}
          setInputs={setInputs}
          inputValue={inputs["Modular Scale"]}
        />
        <TypographyInput
          label="L-XXL Line Height"
          inputs={inputs}
          setInputs={setInputs}
          inputValue={inputs["L-XXL Line Height"]}
        />
      </div>
    </div>
  );
};

export default TypographyInputs;
